import Vue from 'vue'
import App from './index.vue'
import promise from 'es6-promise';
promise.polyfill();
import api from '@/api/index'
import bus from '@/components/newsComponents/bus'
import message from "@/util/message";
Vue.use(message);

// vue-提示组件
import { Message, MessageBox, Notification } from 'element-ui';
Vue.prototype.$notify = Notification;
// 系统使用ie低版本提示
import 'babel-polyfill';
if (navigator.appName == "Microsoft Internet Explorer" && parseInt(navigator.appVersion.split(";")[1].replace(/[ ]/g, "").replace("MSIE", "")) < 9) {
    MessageBox.alert('您的浏览器版本过低，请使用IE9及以上版本！', '系统提示', {
        confirmButtonText: '确定',
        callback: action => {
            Message({
                message: '您的浏览器版本过低，请使用IE9及以上版本！',
                type: 'warning',
                duration: 10000
            })
        }
    });
    // Message.warning({ title: '', message: '您的浏览器版本过低，请使用IE10及以上版本！'});
}

Vue.prototype.$message = Message;

// 获取用户信息
let params = window.location.href.split('?')
let obj = {}
let typeObj = {}


let ticket;
let back;

if (params.length > 1) {
    let types = params[1].split('&')
    if (types.length > 0) {
        types.forEach(e => {
            let arr = e.split('=')
            if (arr.length > 1) {
                if (arr[0] == 'back') {
                    back = arr[1]
                }
                if (arr[0] == 'ticket') {
                    ticket = arr[1]
                }
            }
        })
    }

    api.doLoginByTicket({ticket: ticket}).then(res => {
        if(res.data.code === 200) {
            api.addRequestHeader(res.data.data);
            window.localStorage.setItem('clientToken', res.data.data);
            window.location.href = back ? decodeURIComponent(back) : '/';
        } else {
            console.log(res);
        }
    })

} else {
    if(window.localStorage.getItem("clientToken")){
        api.getLoginInfo().then(res => {
            let data = res;
            window.sessionStorage.setItem('authMenu', JSON.stringify(data.result.authMenu)) //个人中心菜单
            window.sessionStorage.setItem('authButton', JSON.stringify(data.result.authButton)) //按钮
            window.sessionStorage.setItem('officialWebsiteUserMsg', JSON.stringify(data.userMsg)) //个人信息
            window.sessionStorage.setItem('unifiedSocialCreditCode', (data.companyInfo && data.companyInfo.length > 0) ? data.companyInfo[0].unifiedSocialCreditCode : '') //社会信用代码
            window.sessionStorage.setItem('companId', (data.companyInfo && data.companyInfo.length > 0) ? data.companyInfo[0].companyId : '') //企业ID
            window.sessionStorage.setItem('webServerIds', JSON.stringify(data.webServerIds))
            window.sessionStorage.setItem('isLogin', true) //登录信息
            bus.$emit("islogin",true)
            if(data.userMsg.webUserName=='bjcbecsys' ){
                setTimeout(()=>{
                    bus.$emit("openDrop")
                },800)
            }
        }).catch((error) => {
            console.log(error)
        })
    }
}


// if (params.length > 1) {
//     if (typeObj.type) {
//         api.getLoginInfo().then(res => {
//             let iv = '30313233343536373839414243444546';
//             let key = '31323334353637383930414243444546';
//             let data = JSON.parse(Decrypt(res.token, key, iv));
//             // 增加请求头
//             window.sessionStorage.setItem('clientToken',data.clientToken) //请求头token
//             api.addRequestHeader(data.clientToken);
//
//             window.sessionStorage.setItem('authMenu', JSON.stringify(data.result.authMenu)) //个人中心菜单
//             window.sessionStorage.setItem('authButton', JSON.stringify(data.result.authButton)) //按钮
//             window.sessionStorage.setItem('officialWebsiteUserMsg', JSON.stringify(data.userMsg)) //个人信息
//             window.sessionStorage.setItem('unifiedSocialCreditCode', data.companyInfo ? data.companyInfo.unifiedSocialCreditCode : '') //社会信用代码
//             window.sessionStorage.setItem('companId', data.companyInfo ? data.companyInfo.companyId : '') //企业ID
//             window.sessionStorage.setItem('webServerIds', JSON.stringify(data.webServerIds))
//             window.sessionStorage.setItem('isLogin', true) //登录信息
//             bus.$emit("islogin",true)
//             if(data.userMsg.webUserName=='bjcbecsys' ){
//                 setTimeout(()=>{
//                     bus.$emit("openDrop")
//                 },800)
//             }
//         }).catch((error) => {
//             console.log(error)
//         })
//     } else {
//         api.doLoginByTicket().then(res => {
//             console.log(res)
//             if(res.code === 200) {
//                 localStorage.setItem('satoken', res.data);
//                 location.href = decodeURIComponent(back);
//             } else {
//                 alert(res.msg);
//             }
//         })
//         // api.getCookies({ jsessionid: obj.jsessionid }).then(res => {
//         //     api.getLoginInfo().then(res => {
//         //         let iv = '30313233343536373839414243444546';
//         //         let key = '31323334353637383930414243444546';
//         //         let data = JSON.parse(Decrypt(res.token, key, iv));
//         //         // 增加请求头
//         //         window.sessionStorage.setItem('clientToken',data.clientToken) //请求头token
//         //         api.addRequestHeader(data.clientToken);
//         //
//         //         window.sessionStorage.setItem('authMenu', JSON.stringify(data.result.authMenu)) //个人中心菜单
//         //         window.sessionStorage.setItem('authButton', JSON.stringify(data.result.authButton)) //按钮
//         //         window.sessionStorage.setItem('officialWebsiteUserMsg', JSON.stringify(data.userMsg)) //个人信息
//         //         window.sessionStorage.setItem('unifiedSocialCreditCode', data.companyInfo ? data.companyInfo.unifiedSocialCreditCode : '') //社会信用代码
//         //         window.sessionStorage.setItem('companId', data.companyInfo ? data.companyInfo.companyId : '') //企业ID
//         //         window.sessionStorage.setItem('companyCode', data.companyInfo ? data.companyInfo.customsRecordNo : '') //企业编码
//         //         window.sessionStorage.setItem('webServerIds', JSON.stringify(data.webServerIds))
//         //         window.sessionStorage.setItem('isLogin', true) //登录信息
//         //         bus.$emit("islogin",true)
//         //         if(data.userMsg.webUserName=='bjcbecsys' ){
//         //             setTimeout(()=>{
//         //                 bus.$emit("openDrop")
//         //             },800)
//         //         }
//         //     }).catch((error) => {
//         //         console.log(error)
//         //     })
//         // }).catch((error) => {
//         //     console.log(error)
//         // })
//     }
// }

// //引用AES源码js
import CryptoJS from 'crypto-js'
import 'aes'
let Decrypt = function(word, keyStr, ivStr) {
    var key = CryptoJS.enc.Hex.parse(keyStr)
    var iv = CryptoJS.enc.Hex.parse(ivStr)
    var dec = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(word), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(dec)
}

// 引入公共样式
import '@/stylesheets/main.scss';
import 'element-ui/lib/theme-chalk/index.css';


// api共用接口js
Vue.prototype.$api = api;
Vue.config.productionTip = false

new Vue({
    render: h => h(App),
}).$mount('#app')
